module.exports = __webpack_public_path__ + "img/books.ace24f76.svg";